// import React, { Fragment } from "react";
// import { Text, View, StyleSheet } from "@react-pdf/renderer";
// // import { style } from '@mui/system';
// // import {
// //     blueGrey
// //   } from '@mui/material/colors'
// //   import {
// //     createTheme
// //   } from '@mui/material/styles';

// // const theme = createTheme({
// //     palette: {
// //         primary: {
// //             main: blueGrey[900],
// //         },
// //         secondary: {
// //             main: blueGrey[300],
// //         },
// //     },
// //   });

// const borderColor = "#c8c6c4";
// const styles = StyleSheet.create({
//   row: {
//     flexDirection: "row",
//     borderColor: borderColor,
//     // borderBottomWidth: 1,
//     // borderLeftWidth: 1,
//     // borderRightWidth: 1,
//     alignItems: "center",
//     // fontStyle: 'bold',
//     paddingRight: 8,
//     paddingLeft: 8,
//   },
//   description: {
//     width: "40%",
//     textAlign: "center",
//     borderColor: borderColor,
//     borderLefttWidth: 1,
//     borderRightWidth: 1,
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   qty: {
//     width: "10%",
//     borderColor: borderColor,
//     borderRightWidth: 1,
//     textAlign: "center",
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   UM: {
//     width: "7%",
//     borderColor: borderColor,
//     borderRightWidth: 1,
//     textAlign: "center",
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   rate: {
//     width: "20%",
//     borderColor: borderColor,
//     borderRightWidth: 1,
//     textAlign: "center",
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   SKU: {
//     width: "15%",
//     borderColor: borderColor,
//     borderRightWidth: 1,
//     borderLeftWidth: 1,
//     textAlign: "center",
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   SNo: {
//     width: "5%",
//     borderColor: borderColor,
//     borderLeftWidth: 1,
//     textAlign: "center",
//     fontSize: 9,
//     borderBottomWidth: 1,
//   },
//   amount: {
//     width: "15%",
//     textAlign: "center",
//     fontSize: 9,
//     borderRightWidth: 1,
//     borderBottomWidth: 1,
//     borderColor: borderColor,
//   },
// });

// const InvoiceTableRow = ({ invoice, items }) => {
//   console.log("InvoiceTableRow items", invoice);
//   const rows = invoice?.products
//     .filter((item) => item.quantity > 0) // Only include if quantity > 0
//     .map((item, index) => (
//       <Fragment key={index}>
//         <View style={styles.SNo} wrap={false}>
//           <Text>{item.clin_id}</Text>
//         </View>
//         <View style={styles.SKU} wrap={false}>
//           <Text>{item.sku_id}</Text>
//         </View>
//         <View style={styles.description} wrap={false}>
//           <Text>{String(item.description)}</Text>
//         </View>
//         <View style={styles.qty} wrap={false}>
//           <Text>{item.quantity}</Text>
//         </View>
//         <View style={styles.rate} wrap={false}>
//           <Text>
//             {"$ " +
//               Number(item.customer_price).toLocaleString("en-US", {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//               })}
//           </Text>
//         </View>
//         <View style={styles.amount} wrap={false}>
//           <Text>
//             {"$ " +
//               Number(item.quantity * item.customer_price).toLocaleString(
//                 "en-US",
//                 {
//                   minimumFractionDigits: 2,
//                   maximumFractionDigits: 2,
//                 }
//               )}
//           </Text>
//         </View>
//       </Fragment>
//     ));
//   // const rows = items.map((item, index) => (
//   //   <>
//   //     <View style={styles.SKU} wrap={false}>
//   //       <Text>{item.sku_id}</Text>
//   //     </View>
//   //     <View style={styles.description} wrap={false}>
//   //       <Text>{String(item.description)}</Text>
//   //     </View>
//   //     <View style={styles.qty} wrap={false}>
//   //       <Text>{item.quantity}</Text>
//   //     </View>
//   //     <View style={styles.rate} wrap={false}>
//   //       <Text>
//   //         {"$ " +
//   //           Number(item.customer_price).toLocaleString("en-US", {
//   //             minimumFractionDigits: 2,
//   //             maximumFractionDigits: 2,
//   //           })}
//   //       </Text>
//   //     </View>
//   //     <View style={styles.amount} wrap={false}>
//   //       <Text>
//   //         {"$ " +
//   //           Number(item.quantity * item.customer_price).toLocaleString(
//   //             "en-US",
//   //             { minimumFractionDigits: 2, maximumFractionDigits: 2 }
//   //           )}
//   //       </Text>
//   //     </View>
//   //   </>
//   // ));
//   return <Fragment>{rows}</Fragment>;
// };

// export default InvoiceTableRow;

import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { trimTrailingZeros } from "../../../utils/_helpers";

const borderColor = "#c8c6c4";

// Default styles
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderColor: borderColor,
    alignItems: "center",
    paddingRight: 8,
    paddingLeft: 8,
  },
  description: {
    textAlign: "center",
    borderColor: borderColor,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    fontSize: 9,
    borderBottomWidth: 1,
  },
  qty: {
    borderColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    fontSize: 9,
    borderBottomWidth: 1,
  },
  rate: {
    borderColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    fontSize: 9,
    borderBottomWidth: 1,
  },
  SKU: {
    borderColor: borderColor,
    // borderRightWidth: 1,
    borderLeftWidth: 1,
    textAlign: "center",
    fontSize: 9,
    borderBottomWidth: 1,
  },
  amount: {
    textAlign: "center",
    fontSize: 9,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: borderColor,
  },
  SNo: {
    borderColor: borderColor,
    borderLeftWidth: 1,
    textAlign: "center",
    fontSize: 9,
    borderBottomWidth: 1,
  },
});

const InvoiceTableRow = ({ invoice, items }) => {
  const showSNo = invoice?.products?.some((item) => item.clin_id); // Check if any product has clin_id

  // Dynamically adjust column widths based on whether clin_id exists
  const descriptionWidth = showSNo ? "35%" : "34%";
  const SKUWidth = showSNo ? "17%" : "21%";
  const qtyWidth = showSNo ? "10%" : "11%";
  const rateWidth = showSNo ? "18%" : "19%";
  const amountWidth = showSNo ? "15%" : "15%";
  const SNoWidth = showSNo ? "5%" : "0%";

  console.log("showSNo", showSNo);
  const rows = invoice?.products
    .filter((item) => item.quantity > 0) // Only include if quantity > 0
    .map((item, index) => (
      <Fragment key={index}>
        {/* Conditionally render SNo column */}
        {showSNo && (
          <View style={{ ...styles.SNo, width: SNoWidth }} wrap={false}>
            <Text>{String(item.clin_id).toUpperCase()}</Text>
          </View>
        )}
        <View style={{ ...styles.SKU, width: SKUWidth }} wrap={false}>
          <Text>{item.name}</Text>
        </View>
        <View
          style={{ ...styles.description, width: descriptionWidth }}
          wrap={false}
        >
          <Text>{String(item.description)}</Text>
        </View>
        <View style={{ ...styles.qty, width: qtyWidth }} wrap={false}>
          <Text>{trimTrailingZeros(item.quantity)}</Text>
        </View>
        <View style={{ ...styles.rate, width: rateWidth }} wrap={false}>
          <Text>
            {"$ " +
              Number(item.customer_price).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
          </Text>
        </View>
        <View style={{ ...styles.amount, width: amountWidth }} wrap={false}>
          <Text>
            {"$ " +
              Number(item.quantity * item.customer_price).toLocaleString(
                "en-US",
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
          </Text>
        </View>
      </Fragment>
    ));

  return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;
